import { Component, Input} from '@angular/core';

@Component({
  selector: 'property-side-card',
  templateUrl: './property-side-card.component.html',
  styleUrls: ['./property-side-card.component.scss']
})
export class PropertySideCardComponent {
  @Input() icon: string;
  @Input() heading: string;
  @Input() callToActionLink: string;
  @Input() callToActionText: string;

}
